import Request from './request'

const Device_Traffic_Alerts = {
  getTrafficNotification(callback) {
    Request.get('device-traffic-alerts').then(callback).catch(this.bad_answer)
  },
}
export default Device_Traffic_Alerts
